import { Box, Typography, useMediaQuery } from "@mui/material";
import { AnimateTourCard } from "components/AnimateTourCard";

export const RelatedTours = () => {
  const isMobile = useMediaQuery("(max-width:600px)");
  const isTable = useMediaQuery("(min-width:768px) and (max-width: 1200px) ");
  const cardData = [0, 1, 2, 3];
  return (
    <>
      <Typography variant="h4" align="center" mt={isMobile ? 50 : 30} mb={12}>
        NUEVAS OFERTAS
      </Typography>
      <Box
        display="flex"
        flexDirection="row-reverse"
        height={isMobile ? "auto" : 573}
        overflow={isMobile ? "auto" : "hidden"}
        justifyContent={isMobile ? "normal" : "center"}
        gap={10}
        margin={5}
        mb={50}>
        {cardData.slice(isTable ? 2 : 0).map((item, index) => (
          <Box
            key={index}
            display="flex"
            alignItems={isMobile ? "center" : index % 2 === 0 ? "flex-end" : "flex-start"}>
            <AnimateTourCard
              width={255}
              cardOfert
              isExtended={false}
              image="https://www.incatrilogytours.com/wp-content/uploads/2023/10/Vistadome.jpg"
              title="Cusco"
              name="Cusco"
              description="Descubre Cusco: unión de pasado inca y legado colonial. Adéntrate en templos, fortalezas y escenarios andinos, conectando con la esencia de Perú."
              price="100"
            />
          </Box>
        ))}
      </Box>
    </>
  );
};
